export const examAdminSystemSettings = {
  pageTitle: "システム管理",
  pageSubtitle: "サイト、AI 接続、セキュリティポリシー、監査設定の入口。",
  infoBanner: "システム設定はデータベースに永続化され、変更は監査ログに記録されます。",
  currentConfig: "現在のシステム設定",
  platformName: "プラットフォーム名",
  candidatePortalBaseUrl: "受験ログイン URL",
  environment: "実行環境",
  databaseBackend: "データベースバックエンド",
  judgeBackend: "採点バックエンド",
  environmentBackend: "環境バックエンド",
  aiBackend: "AI バックエンド",
  assetStorageBackend: "アセットストレージバックエンド",
  capabilityMatrix: "プラットフォーム能力マトリクス",
  roles: "ロール",
  questionTypes: "問題タイプ",
  paperTypes: "試験セットタイプ",
  judgeLanguages: "採点言語",
  environmentQuestionTypes: "環境対応問題タイプ",
  siteSettings: "サイト設定",
  saveSiteSettings: "サイト設定を保存",
  uploadLogo: "サイトロゴをアップロード",
  uploadFavicon: "サイトアイコンをアップロード",
  logoUploaded: "サイトロゴをアップロードしました",
  faviconUploaded: "サイトアイコンをアップロードしました",
  logoUploadFailed: "サイトロゴのアップロードに失敗しました",
  faviconUploadFailed: "サイトアイコンのアップロードに失敗しました",
  logoUrl: "サイトロゴ URL",
  logoAssetId: "サイトロゴアセット ID",
  faviconUrl: "サイトアイコン URL",
  faviconAssetId: "サイトアイコンアセット ID",
  maintenanceMode: "メンテナンスモード",
  aiSettings: "AI 接続設定",
  saveAiSettings: "AI 設定を保存",
  endpoint: "エンドポイント URL",
  defaultModel: "デフォルトモデル",
  apiKey: "API キー（現在：{value}）",
  securitySettings: "セキュリティポリシー",
  saveSecuritySettings: "セキュリティポリシーを保存",
  requirePasswordChangeOnFirstLogin: "初回ログイン時にパスワード変更を必須にする",
  maxFailedLoginAttempts: "パスワード失敗時のロック閾値",
  lockMinutes: "ロック時間（分）",
  captchaEnabled: "ログイン認証コードを有効化",
  captchaFailThreshold: "連続失敗時の認証コード発動閾値",
  candidateAllowIpRanges: "受験者ログイン許可 IP 範囲（1行1件、CIDR/単一IP）",
  candidateDenyIpRanges: "受験者ログイン拒否 IP 範囲（1行1件、CIDR/単一IP）",
  adminAllowIpRanges: "管理ログイン許可 IP 範囲（1行1件、CIDR/単一IP）",
  adminDenyIpRanges: "管理ログイン拒否 IP 範囲（1行1件、CIDR/単一IP）",
  candidateAllowMultiLogin: "受験者の多端末同時ログインを許可",
  staffAllowMultiLogin: "考務スタッフの多端末同時ログインを許可",
  judgeSettings: "採点イメージ設定",
  judgeSettingsHint:
    "exam-judge の Python / Node / Go 実行イメージ識別子を設定します。「即時反映」（リクエストごとに送信）または「再起動後に反映」（保存のみ）を選択できます。",
  saveJudgeSettings: "採点設定を保存",
  judgeImagePython: "Python 実行イメージ識別子",
  judgeImageNode: "Node 実行イメージ識別子",
  judgeImageGo: "Go 実行イメージ識別子",
  judgeApplyMode: "反映方式",
  judgeApplyModeImmediate: "即時反映",
  judgeApplyModeRestart: "再起動後に反映",
  containerHostPortAssignMode: "コンテナのホストポート割り当てモード",
  containerHostPortAssignModeRandom: "ランダム割り当て",
  containerHostPortAssignModeSequential: "連番割り当て",
  containerHostPortRangeHint:
    "この範囲内でのみホストポートを割り当てます（実操/攻防体験コンテナ向け）。",
  containerHostPortRangeStart: "ホストポート開始値",
  containerHostPortRangeEnd: "ホストポート終了値",
  containerHostPortRangeInvalid: "終了ポートは開始ポート以上である必要があります",
  storageSettings: "オブジェクトストレージ設定",
  saveStorageSettings: "ストレージ設定を保存",
  storageBackend: "ストレージバックエンド",
  storageBackendLocal: "ローカル（local）",
  storageBackendOSS: "Alibaba Cloud OSS",
  integrationSettings: "プラットフォーム連携設定",
  saveIntegrationSettings: "連携設定を保存",
  integrationHint:
    "優先順位: system setting > env fallback > default。空欄のままなら回退値を使います。",
  integrationEffectiveValue: "現在の有効値: {value}",
  integrationSource: "ソース: {source}",
  integrationFallbackHint: "現在の回退値を入力欄へ入れるには「リセット」を使ってください。",
  integrationReset: "リセット",
  ossEndpoint: "OSS Endpoint",
  ossRegion: "OSS Region",
  ossBucket: "Bucket",
  ossPrefix: "オブジェクト接頭辞（任意）",
  ossUseHttps: "HTTPS を使用",
  ossAccessKeyId: "AccessKey ID（現在：{value}）",
  ossAccessKeySecret: "AccessKey Secret（現在：{value}）",
  siteSaved: "サイト設定を保存しました",
  aiSaved: "AI 接続設定を保存しました",
  securitySaved: "セキュリティポリシーを保存しました",
  judgeSaved: "採点イメージ設定を保存しました",
  storageSaved: "オブジェクトストレージ設定を保存しました",
};
